<div id="app">
    <a href="#content" class="skip-link">Skip to main content</a>

    @if (!currentUserError && !isCurrentUserLoading()) {
        <aside>
            <app-sidebar></app-sidebar>
        </aside>
    }

    <div id="layout" [ngClass]="isSidebarCollapsed ? 'collapsed-sidebar' : 'expanded-sidebar'">
        @if (!currentUserError && !isCurrentUserLoading()) {
            <div id="header-container">
                <app-header></app-header>
            </div>
        }

        <main id="content" tabindex="-1">
            @if (isCurrentUserLoading()) {
                <app-loader [globalLoader]="true"></app-loader>
            }

            <div [style.hidden]="isCurrentUserLoading()">
                <router-outlet></router-outlet>
            </div>

            <impersonation-modal
                [isVisible]="displayImpersonationModal"
                [triggerHide]="hideImpersonationModal"
                (onHide)="displayImpersonationModal = false; hideImpersonationModal = false"></impersonation-modal>
            <account-info-verification-modal />
        </main>

        <div id="app-footer">
            <app-footer></app-footer>
        </div>
    </div>

    <div id="mobile-footer" class="no-print">
        <app-mobile-menu></app-mobile-menu>
    </div>
</div>

<p-toast
    id="error-messages-anchor"
    position="top-center"
    [key]="toasterPositions.TOP_CENTER"
    [preventOpenDuplicates]="true">
</p-toast>
<p-toast
    id="warning-success-messages-anchor"
    position="bottom-right"
    [key]="toasterPositions.BOTTOM_RIGHT"
    [preventOpenDuplicates]="true">
</p-toast>
